module.exports = __webpack_public_path__ + "static/PF-cb29dc27fbba129ac1f359266dc3704f.png";